import React from "react";
import classNames from "classnames";
import styles from "./orderForm.module.scss";
import { NowServiceTier } from "../types";
import { NOW_SERVICE_TIER_OPTIONS } from "../orderFormConfig";
import radioOff from "../../../static/ride-order/ic_check.svg";
import radioOn from "../../../static/ride-order/ic_checked.svg";

type ServiceTierPickerProps = {
  selected: NowServiceTier;
  onChange: (tier: NowServiceTier) => void;
};

const ServiceTierPicker: React.FC<ServiceTierPickerProps> = ({ selected, onChange }) => (
  <div className={styles.vehiclePickerWrap}>
    <span className={styles.vehiclePickerLabel}>Service</span>
    <div className={styles.vehiclePickerRow} role="radiogroup" aria-label="Service tier">
      {NOW_SERVICE_TIER_OPTIONS.map((option) => {
        const isSelected = selected === option.id;

        return (
          <button
            key={option.id}
            type="button"
            className={classNames(styles.vehiclePickerCard, {
              [styles.vehiclePickerCardSelected]: isSelected,
            })}
            onClick={() => onChange(option.id)}
            aria-pressed={isSelected}
          >
            <img
              className={styles.vehiclePickerRadio}
              src={isSelected ? radioOn : radioOff}
              alt=""
              aria-hidden
            />
            <span className={styles.vehiclePickerImageWrap}>
              <img className={styles.vehiclePickerImage} src={option.image} alt={option.label} />
            </span>
            <span className={styles.vehiclePickerTitle}>{option.label}</span>
          </button>
        );
      })}
    </div>
  </div>
);

export default ServiceTierPicker;
